import { AUTH_ACTION } from '../interface';
import * as api from '../api/index';

//@ts-ignore
export const signin = (formData, router) => async (dispatch) => {
  try {
    await dispatch({type:AUTH_ACTION.START_LOADING});
    console.log("inside signin");
    let data;
    // const { data } = 
    await api.signIn(formData).then(function (response) {
      data = response.data;
      console.log(data);
      dispatch({ type: AUTH_ACTION.AUTH, payload:data });
      dispatch({type:AUTH_ACTION.END_LOADING});
      router.push('/startup/dashboard');
      console.log("login success responses")
      
    }).catch(function (error) {
      console.log("error status");
      // console.log(error.response.status);
      dispatch({ type: AUTH_ACTION.ERROR, payload:error.response });
      console.log("come back after dispatch error");
      dispatch({type:AUTH_ACTION.END_LOADING});
      data = error;
      console.log("login error responses");
      console.log(error.response.data.message);
    });
    // console.log("data");
    // console.log(data);
  } catch (error) {
    console.log(error);
  }
};

//@ts-ignore
export const signup = (formData, router) => async (dispatch) => {
  try {
    await dispatch({type:AUTH_ACTION.START_LOADING});
    let data;
    await api.signUp(formData).then(function (response) {
      data = response;
      console.log(data);
      // dispatch({ type: AUTH_ACTION.AUTH, payload:data });
      dispatch({type:AUTH_ACTION.END_LOADING});
      console.log("signup success responses");
      console.log(formData.userType);
      
    }).catch(function (error) {
      console.log("error status");
      // console.log(error.response.status);
      dispatch({ type: AUTH_ACTION.SIGNUP_ERROR, payload:error.response });
      dispatch({type:AUTH_ACTION.END_LOADING});
      data = error;
      console.log("login error responses");
      console.log(error.response.data.message);
    });

  } catch (error) {
    console.log(error);
  }
};